export default {
    // 获取系统语言
    getOSlanguage() {
        let languageType = "zh-CN";
        const language = (navigator.browserLanguage || navigator.language).toLowerCase();
        if (language.indexOf("zh") > -1) {
            // 中文
            languageType = "zh-CN";
        } else if (language.indexOf("en") > -1) {
            // 英文
            languageType = "en-US";
        } else if (language.indexOf("ja") > -1) {
            // 日文
            languageType = "ja";
        } else if (language.indexOf("ko") > -1) {
            // 韩文
            languageType = "ko";
        } else if (language.indexOf("fr") > -1) {
            // 法文
            languageType = "fr";
        } else if (language.indexOf("de") > -1) {
            // 德文
            languageType = "de";
        } else if (language.indexOf("ru") > -1) {
            // 俄文
            languageType = "ru";
        } else if (language.indexOf("ar") > -1) {
            // 阿拉伯文
            languageType = "ar";
        } else if (language.indexOf("es") > -1) {
            // 西班牙文
            languageType = "es";
        } else if (language.indexOf("hi") > -1) {
            // 印度文
            languageType = "hi";
        } else if (language.indexOf("it") > -1) {
            // 意大利语
            languageType = "it";
        } else if (language.indexOf("nl") > -1) {
            // 荷兰语
            languageType = "nl";
        } else {
            languageType = language;
        }
        return languageType;
    },
    // 处理微信扫描的内容，取出正确的内容返回
    getResultFromWxScanQR(scanResult) {
        let str = _.trim(_.get(scanResult,"resultStr"));

        if (!str) {
            return "";
        }

        // 一维码，条码
        if (str.indexOf(",") > 0) {
            return str.split(",")[1];
        }

        return str; 
    },
    getTimezone() {
        if (window.dockerConfig && window.dockerConfig.dockerName === "mp") return ""
        const str = Intl.DateTimeFormat().resolvedOptions().timeZone
        return encodeURIComponent(str)
    },
    // 获取ChannelType
    getChannelType() {
    // channelType  W:网站，X：微信， M:H5 wap查询， T:电话， S:短信， I：接口查询
        let channelType = "";
        const ua = window.navigator.userAgent.toLowerCase();
        if (ua.indexOf("mobile") > -1) {
            channelType = "M";
            if (ua.indexOf("micromessenger") > -1) {
                channelType = "X";
            }
        } else {
            channelType = "W";
        }
        return channelType;
    }
    
}
